const custom = [

  //* ——— Bookings ——————————————————
  {
    path: '/Bookings/',
    name: 'bookings-list',
    component: () => import('@/views/bookings/BookingsList.vue'),
    meta: {
      layout: 'content',
    },
  },

  //* ——— Notes ——————————————————
  {
    path: '/Notes/',
    name: 'notes-list',
    component: () => import('@/views/notes/NotesList.vue'),
    meta: {
      layout: 'content',
    },
  },

  //* ——— Payments ——————————————————
  {
    path: '/Payments/',
    name: 'payments-list',
    component: () => import('@/views/payments/PaymentsList.vue'),
    meta: {
      layout: 'content',
    },
  },

  //* ——— AddOns ——————————————————
  {
    path: '/AddOns/',
    name: 'addOns-list',
    component: () => import('@/views/addOns/AddOnsList.vue'),
    meta: {
      layout: 'content',
    },
  },

  //* ——— Promos ——————————————————
  {
    path: '/Promos/',
    name: 'promos-list',
    component: () => import('@/views/promos/PromosList.vue'),
    meta: {
      layout: 'content',
    },
  },

  //* ——— Events ——————————————————
  {
    path: '/Events/',
    name: 'events-list',
    component: () => import('@/views/events/EventsList.vue'),
    meta: {
      layout: 'content',
    },
  },

]

export default custom
